import React from 'react';
import { ArrowRight, Check } from 'lucide-react';
import { motion } from 'framer-motion';
import TechAmbientIcons from '../TechAmbientIcons/TechAmbientIcons';

export default function OlistFinalCTA() {
  return (
    <section className="bg-gradient-to-br from-[#7f00ff] via-[#5b21b6] to-[#7f00ff] py-32 relative overflow-hidden">
      <TechAmbientIcons section="final" />
      {/* Background Graphic elements */}
      <div className="absolute top-0 right-0 p-32 opacity-20 pointer-events-none translate-x-1/4 -translate-y-1/4">
        <div className="w-[600px] h-[600px] rounded-full border-[80px] border-white/20"></div>
      </div>
      <div className="absolute bottom-0 left-0 p-32 opacity-20 pointer-events-none -translate-x-1/4 translate-y-1/4">
        <div className="w-[400px] h-[400px] rounded-full bg-white/20 blur-[80px]"></div>
      </div>

      <div className="container mx-auto px-6 max-w-4xl relative z-10 text-center flex flex-col items-center">
        <motion.h2 
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-4xl md:text-6xl font-bold text-white tracking-tight leading-tight mb-8"
        >
          Pronto para levar seu negócio <br className="hidden md:block"/> ao próximo nível?
        </motion.h2>

        <motion.div 
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.1 }}
          className="flex flex-col sm:flex-row items-center gap-6 justify-center w-full sm:w-auto"
        >
          <button className="w-full sm:w-auto bg-white text-[#5b21b6] hover:bg-slate-50 px-10 py-5 rounded-full font-bold text-lg shadow-2xl hover:-translate-y-1 transition-all">
            Criar conta grátis
          </button>
          
          <button className="w-full sm:w-auto flex items-center justify-center gap-2 text-white border-2 border-white/30 hover:bg-white/10 px-10 py-5 rounded-full font-bold text-lg transition-all">
            Falar com especialista <ArrowRight className="w-5 h-5" />
          </button>
        </motion.div>

        <motion.div 
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 0.3 }}
          className="flex flex-wrap items-center justify-center gap-x-8 gap-y-4 mt-12 text-white/80 font-medium"
        >
          <div className="flex items-center gap-2">
            <Check className="w-5 h-5 text-teal-300" />
            <span>Teste 30 dias grátis</span>
          </div>
          <div className="flex items-center gap-2">
            <Check className="w-5 h-5 text-teal-300" />
            <span>Sem necessidade de cartão</span>
          </div>
          <div className="flex items-center gap-2">
            <Check className="w-5 h-5 text-teal-300" />
            <span>Cancele quando quiser</span>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
